module.exports = __webpack_public_path__ + "static/media/odonto.63a92764.png";